export const state = {
    snackbar: null
};
export const getters = {};
export const mutations = {
    SET_SNACKBAR(state, snackbar) {
        state.snackbar = snackbar;
    },
    SHOW_NOTIFICATION(state, notification) {
        state.snackbar[notification.type](notification.text);
    }
};
export const actions = {
    setSnackbar({ commit }, snackbar) {
        commit('SET_SNACKBAR', snackbar);
    },
    showNotification({ commit }, notification) {
        commit('SHOW_NOTIFICATION', {
            ...notification
        });
    }
};
